import LocalizationService from '../localization/LocalizationService';

function getDecimalValidatorRegexp(
  maximumFractionDigits,
  decimalSeparator = LocalizationService.getDecimalSeparator(),
) {
  return new RegExp(
    `^[-+]?[0-9]+[${decimalSeparator}]?[0-9]{0,${maximumFractionDigits}}$`,
  );
}

function getFilenameIllegalCharRegexp() {
  return /[*|?:."#<>/\\%\s]/gi;
}

const Validations = {
  getDecimalValidatorRegexp,
  getFilenameIllegalCharRegexp,
};

export default Validations;
